enum ROLES {
  SUPER_ADMIN = 1,
  TENANT_ADMIN = 2,
  TECHNICIAN = 3,
}

export default ROLES;
